<template>

    <v-dialog v-model="dialog" width="500" scrollable>
        <v-card :disabled="load">
            <v-card-title class="pb-2">
                Nuevo tipo de ticket
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pt-6">
                <v-form ref="form">
                    <v-row>
                        <v-col cols="12" sm="12" class="py-0">
                            <v-text-field v-model="tipo" label="Tipo" outlined dense clearable></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="d-flex justify-end pb-4">
                <v-btn color="error" class="mr-3" :disabled="load" @click="dialog = false">
                    Cancelar
                </v-btn>
                <BtnConfirmar :loading="load" @action="guardar()" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import BtnConfirmar from '../util/BtnConfirmar.vue';

export default {
    data() {
        return {
            load: false,
            local: null,
            tipo: ''
        }
    },

    props: {
        value: Boolean,
    },

    async created() {

    },
    computed: {
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
    },
    components: {
        BtnConfirmar,
    },
    watch: {
        dialog(val) {
            this.tipo = ''
        },
    },
    methods: {
        async guardar() {
            this.$store.state.loading = true
            if (this.tipo.length > 0) {
                await this.$store.dispatch('tickets/nuevoTipo', {
                    nombre: this.tipo
                }).then(res => {
                    if (res.exito) {

                        this.$emit('actualizarTipo', res.data)
                        this.dialog = false

                        this.$store.dispatch('show_snackbar', {
                            text: res.message,
                            color: 'success'
                        })
                    } else {
                        this.$store.dispatch('show_snackbar', {
                            text: res.message,
                            color: 'error'
                        })
                    }
                })
            } else {
                this.$store.dispatch('show_snackbar', {
                    text: 'El campo es obligatorio',
                    color: 'warning'
                })
            }
            this.$store.state.loading = false
        },

        setSucursal() {
            const sucursal = this.sucursales.filter(
                suc => suc.familia_id === this.data.empresa
            )
            sucursal.length === 1 ? (this.filtro.sucursal = sucursal[0].id) : null
        },

        limpiar() {
            this.$refs.form.resetValidation()
        }
    }
}
</script>